import { ChangeDetectorRef, Component, HostListener, Input, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { NavigationEnd, Router, Event } from "@angular/router";
import { NgxPermissionsService } from "ngx-permissions";
import { Subscription } from "rxjs";
import { AuthService } from "src/app/@core/services/auth.service";
import { LocalStoreService } from "src/app/@core/services/local-store.service";
import { NotificationService } from "src/app/@core/services/notification.service";
import { SubscriptionService } from "src/app/@core/services/subscription.service";
import { WebsocketService } from "src/app/@core/services/websocket.service";
import { environment } from "src/environments/environment";
import { MessageService } from "../../components/message/message.service";
import { pagesToggleService } from "../toggler/toggler.service";

@Component({
	selector: 'root-layout',
	templateUrl: './root.component.html',
	styleUrls: ['./root.component.scss']
  })
  export class RootLayout implements OnInit, OnDestroy {
	@ViewChild('root', { static: false }) root;
	layoutState: string;
	extraLayoutClass: string;
	_boxed: boolean = false;
	_menuPin: boolean = false;
	_enableHorizontalContainer: boolean;
	_pageContainerClass = '';
	_contentClass = '';
	_footer: boolean = true;
	_menuDrawerOpen: boolean = false;
	//Mobile
	_secondarySideBar: boolean = false;
	//Mobile
	_mobileSidebar: boolean = false;
	//Mobile
	_mobileHorizontalMenu: boolean = false;
	_pageTitle: string;
	//Sub layout - eg: email
	_layoutOption: string;
	_subscriptions: Array<Subscription> = [];
	_layout;
	@Input()
	public contentClass: string = '';
  
	@Input()
	public pageWrapperClass: string = '';
  
	@Input()
	public footer: boolean = true;

	menuLinks = [
		{
			label: 'Calendar',
			routerLink: '/calendar',
			iconType: 'fal',
			iconName: 'fa-calendar-alt',
			//roles:'view_jobsheet',
		  },

		  {
			label: 'Testing',
			routerLink: '/calendar',
			iconType: 'fal',
			iconName: 'fa-calendar-alt',
			//roles:'view_jobsheet',
		  },

		  {
			label: 'Quotes',
			iconType: 'fal',
			iconName: 'fa-money-check',
			toggle: 'close',
			roles:'view_quote',
			submenu: [
			  {
				label: 'All',
				routerLink: '/quote',
				iconType: 'fal',
				iconName: 'fa-money-check',
			  },
			  {
				label: 'Drafts',
				routerLink: '/quote/draft',
				URLSearchParams:{statusQuote:"draft"},
				iconType: 'fal',
				iconName: 'fa-inbox',
			  },
			  {
				label: 'Issued',
				routerLink: '/quote/issued',
				URLSearchParams:{statusQuote:"issued"},
				iconType: 'fal',
				iconName: 'fa-stamp',
			  },
			  {
				label: 'Approved',
				routerLink: '/quote/approved',
				URLSearchParams:{statusQuote:"approved"},
				iconType: 'fal',
				iconName: 'fa-check',
			  },
			]
		  },
	]

  constructor(
    public toggler: pagesToggleService, 
    public router: Router,
    public permissionsService: NgxPermissionsService,
    public store: LocalStoreService,
    public notificationService: NotificationService,
    public subService: SubscriptionService,
    //public utils: Utils,
    public cdr: ChangeDetectorRef,
    public wsService: WebsocketService,
    public authService: AuthService,
	private messageService: MessageService,
    ) {
 

	
	

    router.events.subscribe((event: Event) => {


		
	  if (event instanceof NavigationEnd) {
        var root = this.router.routerState.snapshot.root;
        while (root) {
          if (root.children && root.children.length) {
            root = root.children[0];
          } else if (root.data) {
            //Custom Route Data here
            this._pageTitle = root.data['title'];
            this._layoutOption = root.data['layoutOption'];
            this._boxed = root.data['boxed'];
            break;
          } else {
            break;
          }
        }

        //Close Sidebar and Horizonta Menu
        if (this._mobileSidebar) {
          this._mobileSidebar = false;
          this.toggler.toggleMobileSideBar(this._mobileSidebar);
        }
        this._mobileHorizontalMenu = false;
        this.toggler.toggleMobileHorizontalMenu(this._mobileHorizontalMenu);
        //Scoll Top
        this.scrollToTop();
      }

      //Subscribition List
      this._subscriptions.push(
        this.toggler.pageContainerClass.subscribe(state => {
          this._pageContainerClass = state;
        })
      );

      this._subscriptions.push(
        this.toggler.contentClass.subscribe(state => {
          this._contentClass = state;
        })
      );

      this._subscriptions.push(
        this.toggler.bodyLayoutClass.subscribe(state => {
          if (state) {
            this.extraLayoutClass = state;
          }
        })
      );

      this._subscriptions.push(
        this.toggler.Applayout.subscribe(state => {
          this.changeLayout(state);
        })
      );

      this._subscriptions.push(
        this.toggler.Footer.subscribe(state => {
          this._footer = state;
        })
      );

      this._subscriptions.push(
        this.toggler.mobileHorizontaMenu.subscribe(state => {
          this._mobileHorizontalMenu = state;
        })
      );
    });
  }

  /** @function changeLayout
   *   @description Add Document Layout Class
   */
  changeLayout(type: string) {
    this.layoutState = type;
  }

  /** @function removeLayout
   *   @description Remove Document Layout Class
   */


  ngOnInit() {
    console.log("Init Root");
  }

  dot = false
  currentPage = 1;
  searchParams = { per_page: environment.per_page, page: this.currentPage };
  notifs
  totalNotifactions = []
  Notifsids = []
//   getNotif(){
// 	  let _this = this;
// 	  console.log(this.currentPage)
// 	  _this.notificationService.getAll(this.searchParams).subscribe(res => {
// 		  console.log(res['data']);
// 		  this.notifs = res['data'];
		  

// 		  for(let ids of res['data']){
// 			_this.totalNotifactions.push(ids)
// 			this.Notifsids.push(ids['id'])
// 		  }

// 		  for(let read of res['data']){
// 			console.log(read['read_at']);
// 			if(read['read_at'] == null){
// 				_this.dot = true;
// 				return
// 			}
// 		  }

// 		  console.log(_this.totalNotifactions)
// 	  });
//   }

//   MarkasRead(){
// 	let _this = this;
// 	let ids = { ids: _this.Notifsids};
// 	_this.notificationService.readNotifs(ids).subscribe(res => {
// 		_this.notifs = null;
// 		_this.dot = false;
// 		_this.totalNotifactions = []
// 		console.log('id checked')
// 		_this.getNotif()
// 	})
//   }

//   @HostListener('scroll', ['$event'])
//   onNotifScroll(event: any){
// 	if (event.target.offsetHeight + event.target.scrollTop >= event.target.scrollHeight - 1) {
// 		console.log("End");
// 		this.currentPage = this.currentPage+1
// 		this.searchParams = { per_page: environment.per_page, page: this.currentPage };
// 		console.log(this.currentPage)
// 		this.getNotif();
// 	  }
//   }

//   NotifClicked(ticketid, id){
// 	let _this = this;
// 	console.log(id);
// 	if(id != null){
// 		let ids = { ids: [id]};
// 		_this.router.navigate([`/ticket/` +ticketid]);
// 		_this.notificationService.readNotifs(ids).subscribe(res => {
// 			console.log('id checked')
// 			_this.getNotif()
// 		})
// 	}else{
// 		this.messageService.error('Ticekt has been deleted', { Position: 'bottom-right', Style: 'simple', Duration: 5000 });
// 	}
//   }

  ngOnDestroy() {
    for (const sub of this._subscriptions) {
      sub.unsubscribe();
    }
  }
  ngAfterViewInit() {}

  /** @function scrollToTop
   *   @description Force to scroll to top of page. Used on Route
   */
  scrollToTop() {
    let top = window.pageYOffset;
    if (top == 0) {
      let scroller = document.querySelector('.page-container');
      if (scroller) scroller.scrollTo(0, 0);
    } else {
      window.scrollTo(0, 0);
    }
  }

  /** @function openQuickView
   *   @description Show Quick View Component / Right Sidebar - Service
   */
  openQuickView($e) {
    $e.preventDefault();
    this.toggler.toggleQuickView();
  }

  /** @function openSearch
   *   @description Show Quick Search Component - Service
   */

  openSearch($e) {
    $e.preventDefault();
    this.toggler.toggleSearch(true);
  }

  /** @function toggleMenuPin
   *   @description Permanently Open / Close Main Sidebar
   */
 

  /** @function toggleMenuDrawer
   *   @description Open Main Sidebar Menu Drawer - Service
   */
  toggleMenuDrawer() {
    this._menuDrawerOpen = this._menuDrawerOpen == true ? false : true;
    this.toggler.toggleMenuDrawer();
  }

  /** @function toggleMobileSidebar
   *   @description Open Main Sidebar on Mobile - Service
   */

  /** @function toggleHorizontalMenuMobile
   *   @description Open Secondary Sidebar on Mobile - Service
   */
  toggleSecondarySideBar() {
    console.log('hi');
    this._secondarySideBar = this._secondarySideBar == true ? false : true;
    this.toggler.toggleSecondarySideBar(this._secondarySideBar);
  }

  /** @function toggleHorizontalMenuMobile
   *   @description Call Horizontal Menu Toggle Service for mobile
   */
  toggleHorizontalMenuMobile() {
    this._mobileHorizontalMenu = this._mobileHorizontalMenu == true ? false : true;
    this.toggler.toggleMobileHorizontalMenu(this._mobileHorizontalMenu);
  }



}
